import Vue from 'vue'

/**
 * `tLabel` — tlumaczenie wartosci, ktora jest jednoczesnie identyfikatorem logiki.
 *
 * W repo pelno jest miejsc, gdzie ten sam string jest i etykieta w UI, i wartoscia
 * porownywana w kodzie albo wysylana do API (kategorie widgetow, statusy urzadzen,
 * authority uzytkownika, tryby Menu Board). Tlumaczenie takiej wartosci u zrodla
 * zepsulo by logike, wiec wartosc zostaje angielska, a tlumaczy sie ja dopiero
 * przy renderze.
 *
 *   {{ tLabel(device.status, 'device.status') }}   // klucz: device.status.NORMAL
 *   {{ tLabel(widget.title) }}                     // wartosc juz JEST kluczem i18n
 *
 * Gdy klucza nie ma w slowniku, zwracana jest wartosc wejsciowa — dzieki temu
 * nieprzewidziany enum z API wyswietli sie surowy zamiast zniknac.
 */
Vue.mixin({
  methods: {
    tLabel(value, prefix) {
      if (value === null || value === undefined || value === '') return value

      const key = prefix ? prefix + '.' + value : value

      return this.$te(key) ? this.$t(key) : value
    }
  }
})
